import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2003ea98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex flex-col h-full w-full overflow-hidden px-4" }
const _hoisted_2 = { class: "pt-4 px-4 flex flex-row gap-4" }
const _hoisted_3 = { class: "flex-1 overflow-hidden last-child-padding" }

import { onMounted, reactive, ref } from "vue";
import { productService } from "@/_services";

import { defineComponent } from "vue";
import LbrxCategoryBar from "@/components/LbrxCategoryBar.vue";
import LbrxLoaderSpinner from "@/components/LbrxLoaderSpinner.vue";
import { SaveOutlined, EyeOutlined } from "@ant-design/icons-vue";
const __default__ = defineComponent({
  name: "ConfigPos",
  components: {
    LbrxCategoryBar,
    LbrxLoaderSpinner,
    SaveOutlined,
    // EyeOutlined,
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false);
const categoryBar = ref<InstanceType<typeof LbrxCategoryBar> | null>(
  null
) as any;

const state = reactive({
  affectedProducts: [] as any[],
});
const saveCategoryConfig = () => {
  console.log("save category config");
  if (categoryBar.value) {
    categoryBar.value.updateCategoryRank();
  }
};

const updateAffectedProducts = (
  products: Array<{ id: string; category_id: string; display_rank: number }>
) => {
  state.affectedProducts = products;
  console.log("update affected products in index ", state.affectedProducts);
};

const updateProductsRank = async () => {
  if (state.affectedProducts.length > 0) {
    loading.value = true;
    try {
      const formData = new FormData();
      formData.append("products", JSON.stringify(state.affectedProducts));
      const res = await productService.updateConfig(formData);
      loading.value = false;
    } catch (e) {
      loading.value = false;
      console.error("Error updating product ranks", e);
    }
  } else {
    return;
  }
};

const updateConfig = async () => {
  await saveCategoryConfig();
  await updateProductsRank();
  await categoryBar.value.getCategories();
  state.affectedProducts = [];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LbrxLoaderSpinner, { isLoaded: loading.value }, null, 8, ["isLoaded"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: updateConfig,
          class: "flex px-3 py-3 rounded-md items-center justify-center text-sm gap-2 text-white bg-primary"
        }, [
          _createVNode(_unref(SaveOutlined)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.saveSettings")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(LbrxCategoryBar, {
          loadingData: loading.value,
          "onUpdate:loadingData": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          ref_key: "categoryBar",
          ref: categoryBar,
          "onUpdate:affectedProducts": updateAffectedProducts
        }, null, 8, ["loadingData"])
      ])
    ])
  ], 64))
}
}

})